import axios from 'axios';
import { browserHistory } from 'react-router';
import { SubmissionError, change } from 'redux-form';
import { toFromDates, convertUtcDate } from '../components/Common/cleanDates';

import {
    REQUEST_INVENTORY_CONVERTS,
    FETCH_INVENTORY_CONVERTS_SUCCESS,
    FETCH_INVENTORY_CONVERTS_FAILURE,
    SELECT_INVENTORY_CONVERT,
    RESET_CURRENT_INVENTORY_CONVERT,
    REQUEST_INVENTORY_CONVERT_DETAIL,
    FETCH_INVENTORY_CONVERT_DETAIL_SUCCESS,
    FETCH_INVENTORY_CONVERT_DETAIL_FAILURE,
    REQUEST_INVENTORIES_BIN,
    FETCH_INVENTORIES_BIN_SUCCESS,
    FETCH_INVENTORIES_BIN_FAILURE,
    REQUEST_CREATING_INVENTORY_CONVERT,
    CREATE_INVENTORY_CONVERT_SUCCESS,
    CREATE_INVENTORY_CONVERT_FAILURE,
    REQUEST_EDITING_INVENTORY_CONVERT,
    EDIT_INVENTORY_CONVERT_SUCCESS,
    EDIT_INVENTORY_CONVERT_FAILURE,
    REQUEST_NEW_CONVERT,
    NEW_CONVERT_SUCCESS,
    NEW_CONVERT_FAILURE,
} from './type'

import {
    INVENTORY_CONVERTS_URL,
    INVENTORIES_URL
} from './url';


// InventoryConverts Actions
import { DEFAULT_ERROR } from '../components/Common/constants';
import { isGGI } from './root_url'

export function fetchInventoryConverts() {
    return dispatch => {
        dispatch({ type: REQUEST_INVENTORY_CONVERTS });
        return axios.get(INVENTORY_CONVERTS_URL,
            {
                headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
            })
            .then(response => {
              dispatch(fetchInventoryConvertsSuccess(response));
            }, err => {
              if (err.status === 500 || err.status === 404) {
                err.data = DEFAULT_ERROR;
              }
              if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
                document.getElementById('tokenInvalid').style.display = 'flex'
              } else {
                dispatch(fetchInventoryConvertsFailure(err));                     
              }
            });
    }
}

export function fetchInventoryConvertsSuccess(inventoryConverts) {
    return {
        type: FETCH_INVENTORY_CONVERTS_SUCCESS,
        payload: inventoryConverts
    };
}

export function fetchInventoryConvertsFailure(error) {
    return {
        type: FETCH_INVENTORY_CONVERTS_FAILURE,
        payload: error
    };
}

export function selectInventoryConvert(inventoryConvert) {
    return {
        type: SELECT_INVENTORY_CONVERT,
        payload: inventoryConvert
    };
}

export function resetCurrentInventoryConvert() {
    return {
        type: RESET_CURRENT_INVENTORY_CONVERT
    }
}


export function fetchInventoryConvertDetail(inventoryConvert_id) {
    return dispatch => {
        dispatch({ type: REQUEST_INVENTORY_CONVERT_DETAIL });
        return axios.get(INVENTORY_CONVERTS_URL + inventoryConvert_id,
            {
                headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
            })
            .then(response => {
              dispatch(fetchInventoryConvertDetailSuccess(response));
            }, err => {
              if (err.status === 500 || err.status === 404) {
                err.data = DEFAULT_ERROR;
              }
              if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
                document.getElementById('tokenInvalid').style.display = 'flex'
              } else {
                dispatch(fetchInventoryConvertDetailFailure(err));                     
              }
            });
    }
}

export function fetchInventoryConvertDetailSuccess(inventoryConvertDetail) {
  inventoryConvertDetail = inventoryConvertDetail.data;
  if(inventoryConvertDetail.PostingDate) inventoryConvertDetail.PostingDate = convertUtcDate(inventoryConvertDetail.PostingDate);
    return {
        type: FETCH_INVENTORY_CONVERT_DETAIL_SUCCESS,
        payload: inventoryConvertDetail
    };
}

export function fetchInventoryConvertDetailFailure(error) {
    return {
        type: FETCH_INVENTORY_CONVERT_DETAIL_FAILURE,
        payload: error
    };
}

export function fetchInventories() {
    return dispatch => {
        dispatch({ type: REQUEST_INVENTORIES_BIN });
        return axios.get(INVENTORIES_URL + 'bin/',
            {
                headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
            })
            .then(response => {
              dispatch(fetchInventoriesSuccess(response));
            }, err => {
              if (err.status === 500 || err.status === 404) {
                err.data = DEFAULT_ERROR;
              }
              if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
                document.getElementById('tokenInvalid').style.display = 'flex'
              } else {
                dispatch(fetchInventoriesFailure(err));                     
              }
            });
    }
}

export function fetchInventoriesSuccess(inventories) {
    return {
        type: FETCH_INVENTORIES_BIN_SUCCESS,
        payload: inventories
    };
}

export function fetchInventoriesFailure(error) {
    return {
        type: FETCH_INVENTORIES_BIN_FAILURE,
        payload: error
    };
}


export function createInventoryConvert(
  Warehouse_id,
  PostingDate,
  Note,
  ProcessingFee,
  Warehouse_Convert_Line
) {
    if (PostingDate) PostingDate = convertUtcDate(PostingDate);
    // if(Warehouse_Convert_Line) {
    //   Warehouse_Convert_Line.map(line => {
    //     line['WarehouseBin_id'] = line.WarehouseBin_id.WarehouseBin_id;
    //     line['WarehouseZone_id'] = line.WarehouseZone_id.WarehouseZone_id;
    //   })
    // }
    return dispatch => {
        dispatch({ type: REQUEST_CREATING_INVENTORY_CONVERT });
        axios.post(INVENTORY_CONVERTS_URL,
            {
              Warehouse_id,
              PostingDate,
              Note,
              ProcessingFee,
              Warehouse_Convert_Line
            },
            {
                headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
            }
        )
            .then(response => {
              dispatch(createInventoryConvertSuccess());
              browserHistory.push('/inventories/convert');
            }, err => {
              if (err.status === 500 || err.status === 404) {
                err.data = DEFAULT_ERROR;
              }
              if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
                document.getElementById('tokenInvalid').style.display = 'flex'
              } else {
                dispatch(createInventoryConvertFailure(err));                     
              }
            });
    }
}

export function createInventoryConvertSuccess() {
    return {
        type: CREATE_INVENTORY_CONVERT_SUCCESS
    }
}

export function createInventoryConvertFailure(error) {
    return {
        type: CREATE_INVENTORY_CONVERT_FAILURE,
        payload: error
    }
}

export function editInventoryConvert(
  WarehouseConvert_id,
  Warehouse_id,
  PostingDate,
  Note,
  ProcessingFee,
  Warehouse_Convert_Line
) {
    if (PostingDate) PostingDate = convertUtcDate(PostingDate);
    if(Warehouse_Convert_Line) {
      Warehouse_Convert_Line.map(line => {
        line['WarehouseBin_id'] = line.WarehouseBin_id.WarehouseBin_id;
        line['WarehouseZone_id'] = line.WarehouseZone_id.WarehouseZone_id;
      })
    }
    return dispatch => {
        dispatch({ type: REQUEST_EDITING_INVENTORY_CONVERT });
        axios.put(INVENTORY_CONVERTS_URL + WarehouseConvert_id,
            {
              Warehouse_id,
              PostingDate,
              Note,
              ProcessingFee,
              Warehouse_Convert_Line
            },
            {
                headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
            }
        )
            .then(response => {
              dispatch(editInventoryConvertSuccess());
              browserHistory.push('/inventories/convert');
            }, err => {
              if (err.status === 500 || err.status === 404) {
                err.data = DEFAULT_ERROR;
              }
              if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
                document.getElementById('tokenInvalid').style.display = 'flex'
              } else {
                dispatch(editInventoryConvertFailure(err));                     
              }
            });
    }
}

export function editInventoryConvertSuccess() {
    return {
        type: EDIT_INVENTORY_CONVERT_SUCCESS
    }
}

export function editInventoryConvertFailure(error) {
    return {
        type: EDIT_INVENTORY_CONVERT_FAILURE,
        payload: error
    }
}

export function setField(field, value) {
  return dispatch => {
    dispatch(change('productConvertDetail', field, value));
  }
}

export function createNewConvert({
  ProductNum,
  RelatedProductNum,
  Quantity,
  RelatedQuantity,
}) {
    return dispatch => {
        dispatch({ type: REQUEST_NEW_CONVERT });
        axios.post(INVENTORY_CONVERTS_URL,
            {
              ProductNum,
              RelatedProductNum,
              Quantity,
              RelatedQuantity,
            },
            {
                headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
            }
        )
            .then(response => {
              dispatch(createNewConvertSuccess());
              browserHistory.push('/productConvertReport');
            }, err => {
              if (err.status === 500 || err.status === 404) {
                err.data = DEFAULT_ERROR;
              }
              if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
                document.getElementById('tokenInvalid').style.display = 'flex'
              } else {
                dispatch(createNewConvertFailure(err));                     
              }
            });
    }
}

export function createNewConvertSuccess() {
  return {
    type: NEW_CONVERT_SUCCESS,
  };
}

export function createNewConvertFailure(error) {
  return {
    type: NEW_CONVERT_FAILURE,
    payload: error,
  };
}



// WEBPACK FOOTER //
// ./master/jsx/actions/inventoryConverts_actions.js